var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SyncResponse, SessionInitMessage, SessionCloseMessage, ErrorResponse, SendMessageErrorReason } from '@augloop/session-protocol';
import { SchemaObject } from '@augloop/types-core';
export var SessionState;
(function (SessionState) {
    SessionState[SessionState["Initing"] = 0] = "Initing";
    SessionState[SessionState["Running"] = 1] = "Running";
    SessionState[SessionState["Disconnected"] = 2] = "Disconnected";
    SessionState[SessionState["Closed"] = 3] = "Closed";
})(SessionState || (SessionState = {}));
export var sendMessageNow = function (context, message, onResponse, attemptNumber) {
    if (!message) {
        return;
    }
    if (!message.cv) {
        message.cv = context.cvParent.newChild().toString();
    }
    context.messageEndpoint.sendMessage(message, function (err, resp) {
        // Record when was the last sync message response received
        if (!err && SchemaObject.getTypeNameFor(resp) === SyncResponse.getTypeName()) {
            context.stats.lastSyncMessage = Date.now();
        }
        if (onResponse) {
            onResponse(err, resp);
        }
    }, undefined, attemptNumber);
};
export var queueMessage = function (context, message, onResponse, attemptNumber) {
    if (!message) {
        return;
    }
    context.messageQueue.push(message, onResponse, attemptNumber);
    context.webSocketWorkerManager.init(undefined /*extensionConfigs*/, context.customInitPromise);
};
export var queueBytes = function (context, buffer) {
    if (!buffer) {
        return;
    }
    context.messageQueue.push(buffer);
    context.webSocketWorkerManager.init(undefined /*extensionConfigs*/, context.customInitPromise);
};
var BaseState = /** @class */ (function () {
    function BaseState(context) {
        this.context = context;
    }
    BaseState.prototype.onEnter = function (_params) {
    };
    BaseState.prototype.sendMessage = function (_message, _onResponse, _attemptNumber, _sendOnlyIfConnected) {
    };
    BaseState.prototype.sendBytes = function (_buffer) {
    };
    BaseState.prototype.canSendMessage = function () {
        return false;
    };
    BaseState.prototype.onConnectionClose = function () {
    };
    return BaseState;
}());
export { BaseState };
var InitingState = /** @class */ (function (_super) {
    __extends(InitingState, _super);
    function InitingState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stateName = SessionState.Initing;
        _this.possibleNextStates = [SessionState.Running, SessionState.Disconnected, SessionState.Closed];
        return _this;
    }
    InitingState.prototype.sendMessage = function (message, onResponse, attemptNumber) {
        if (SchemaObject.matchesTypesFor(message, [SessionInitMessage.getTypeName()])) {
            sendMessageNow(this.context, message, onResponse, attemptNumber);
        }
        else {
            queueMessage(this.context, message, onResponse);
        }
    };
    InitingState.prototype.sendBytes = function (buffer) {
        queueBytes(this.context, buffer);
    };
    InitingState.prototype.onConnectionClose = function () {
        this.context.setState(SessionState.Disconnected);
    };
    return InitingState;
}(BaseState));
export { InitingState };
var RunningState = /** @class */ (function (_super) {
    __extends(RunningState, _super);
    function RunningState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stateName = SessionState.Running;
        _this.possibleNextStates = [SessionState.Disconnected, SessionState.Closed];
        return _this;
    }
    RunningState.prototype.onEnter = function (params) {
        if (params && params.isSessionReseedingStarted) {
            this.context.resetNextSyncSequenceId();
        }
        this.context.messageQueue.sendOnSessionInitialized(params && params.isSessionReseedingStarted);
    };
    RunningState.prototype.sendMessage = function (message, onResponse, attemptNumber, _sendOnlyIfConnected) {
        sendMessageNow(this.context, message, onResponse, attemptNumber);
    };
    RunningState.prototype.sendBytes = function (buffer) {
        if (buffer) {
            this.context.webSocketWorkerManager.egressBytes(buffer);
        }
    };
    RunningState.prototype.canSendMessage = function () {
        return true;
    };
    RunningState.prototype.onConnectionClose = function () {
        this.context.setState(SessionState.Disconnected);
    };
    return RunningState;
}(BaseState));
export { RunningState };
var DisconnectedState = /** @class */ (function (_super) {
    __extends(DisconnectedState, _super);
    function DisconnectedState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stateName = SessionState.Disconnected;
        _this.possibleNextStates = [SessionState.Initing, SessionState.Closed];
        return _this;
    }
    DisconnectedState.prototype.onEnter = function (_params) {
        this.context.messageEndpoint.cancelPendingResponseCallbacks();
    };
    DisconnectedState.prototype.sendMessage = function (message, onResponse, attemptNumber, sendOnlyIfConnected) {
        if (SchemaObject.matchesTypesFor(message, [SessionInitMessage.getTypeName()])) {
            this.context.setState(SessionState.Initing);
            sendMessageNow(this.context, message, onResponse, attemptNumber);
        }
        else if (SchemaObject.matchesTypesFor(message, [SessionCloseMessage.getTypeName()])) {
            this.context.setState(SessionState.Closed);
        }
        else {
            if (!sendOnlyIfConnected) {
                queueMessage(this.context, message, onResponse, attemptNumber);
                return;
            }
            if (onResponse) {
                onResponse(new ErrorResponse({ error: SendMessageErrorReason.ClientDisconnected }));
            }
        }
    };
    DisconnectedState.prototype.sendBytes = function (buffer) {
        queueBytes(this.context, buffer);
    };
    return DisconnectedState;
}(BaseState));
export { DisconnectedState };
var ClosedState = /** @class */ (function (_super) {
    __extends(ClosedState, _super);
    function ClosedState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stateName = SessionState.Closed;
        _this.possibleNextStates = [];
        return _this;
    }
    return ClosedState;
}(BaseState));
export { ClosedState };
//# sourceMappingURL=session-states.js.map